import React, { Component } from 'react';
import { graphql } from 'react-relay';
import CsatByDayOfWeekBarChart from '../../../../components/CsatByDayOfWeekBarChart';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query CsatByDayOfWeekWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
            ) {
              count
              ...CsatByDayOfWeekBarChart_answersReport
            }
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter({ subtitleMessageId: 'byDayOfWeek' })
class CsatByDayOfWeekWidget extends Component {
  render() {
    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <CsatByDayOfWeekBarChart
        answersReport={question.answersReport}
        height={this.props.bodyHeight}
        width={this.props.width}
        uniqueId={widget.id}
      />
    );
  }
}

export default CsatByDayOfWeekWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByDayOfWeekWidget/CsatByDayOfWeekWidget.js